import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { DateTimeComponentBase } from '../base/date-time.base';
import { LanguageService } from '../../service/language.service';

@Component({
    selector: 'app-date-time-box',
    templateUrl: './date-time-box.component.html',
    styleUrls: ['./date-time-box.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class DateTimeBoxComponent extends DateTimeComponentBase implements OnInit {
  constructor(languageService: LanguageService) {
    super(languageService);
  }

  @Input() label: string;

  ngOnInit() {}
}
